<div class="col-12">

  <p-timeline [value]="eventData" align="alternate" styleClass="customized-timeline">
    <ng-template pTemplate="marker" let-event>
      <span class="custom-marker shadow-2" [style.backgroundColor]="event.color">
        <i [ngClass]="event.icon"></i>
      </span>
    </ng-template>
    <ng-template pTemplate="content" let-event>
      <p-card [header]="event.status" [subheader]="event.date | date: 'yyyy/MM/dd HH:mm'" *ngIf="event.status != '完成'">

        <div *ngIf="event.no % 2 == 0;then nested_object_content else normal_content"></div>

        <ng-template #nested_object_content>

          <button pButton pRipple class="p-button-outlined p-button-info"
            style="height: 26px; padding: 0.25rem 0.4rem; font-size: 12px;" disabled>
            <i class="pi pi-user" style="font-size: 12px"></i>
            <span class="ml-1" *ngIf="event.approval_man">
              {{event.approval_man}}
            </span>
          </button>

          <span style="white-space: pre-wrap;word-break: break-word;">
            {{event.content}}
          </span>

          <div *ngIf="event.has_rejected_order && event.remark">
            <button pButton label="檢視單據" class="p-button-link mt-2" style="padding: 0rem 0rem;"
              (click)="openDel(event.type,event.remark)"></button>
          </div>

          <div *ngIf="!event.has_rejected_order && event.remark" class="mt-2">
            <span style="white-space: pre-wrap;word-break: break-word;">
              {{event.remark}} - {{event.remarked_at | date: 'yyyy/MM/dd HH:mm'}}
            </span>
          </div>

        </ng-template>

        <ng-template #normal_content>

          <span style="white-space: pre-wrap;word-break: break-word;">
            {{event.content}}
          </span>

          <button pButton pRipple class="p-button-outlined p-button-info"
            style="height: 26px; padding: 0.25rem 0.4rem; font-size: 12px;" disabled>
            <i class="pi pi-user" style="font-size: 12px"></i>
            <span class="ml-1" *ngIf="event.approval_man">
              {{event.approval_man}}
            </span>
          </button>

          <div *ngIf="event.has_rejected_order  && event.remark">
            <button pButton label="檢視單據" class="p-button-link mt-2" style="padding: 0rem 0rem;"
              (click)="openDel(event.type,event.remark)"></button>
          </div>

          <div *ngIf="!event.has_rejected_order && event.remark" class="mt-2">
            <span style="white-space: pre-wrap;word-break: break-word;">
              {{event.remark}} - {{event.remarked_at | date: 'yyyy/MM/dd HH:mm'}}
            </span>
          </div>

        </ng-template>


      </p-card>

    </ng-template>
  </p-timeline>
</div>